import {useParams} from 'react-router-dom';

import appContent from '@/services/content/appContent';
import connectivityService from '@/services/device/connectivityService';

const getConnectionGuideByDeviceType = (deviceType) => {
    const isBle = connectivityService.isBle();
    const connectionGuide = isBle ? appContent.getPairingGuide() : appContent.getConnectionGuide();

    return connectionGuide.find((guide) => guide.deviceTypes.some((type) => type.deviceType === deviceType));
};

const useConnectionGuidePageContent = () => {
    const {deviceType} = useParams();
    const connectionGuide = getConnectionGuideByDeviceType(deviceType);

    if (!connectionGuide) {
        throw new Error(`Connection guide not found for device type: ${deviceType}`);
    }

    const contentItems = connectionGuide.items;

    return {deviceType, contentItems};
};

export default useConnectionGuidePageContent;
